import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileComponent } from './profile/profile.component';
import { canDeactivateGuard } from '../core/guards/can-deactivate.guard';
import { BookMasterComponent } from './operator/book-master/book-master.component';
import { MemberMasterComponent } from './operator/member-master/member-master.component';
import { AuthorMasterComponent } from './operator/author-master/author-master.component';
import { CategoryMasterComponent } from './operator/category-master/category-master.component';
import { LanguageMasterComponent } from './operator/language-master/language-master.component';
import { ClosureReasonMasterComponent } from './operator/closure-reason-master/closure-reason-master.component';
import { UserMasterComponent } from './operator/user-master/user-master.component';
import { RouteMasterComponent } from './operator/route-master/route-master.component';
import { CenterMasterComponent } from './operator/center-master/center-master.component';
import { BarcodeLabelsComponent } from './operator/barcode-labels/barcode-labels.component';
import { IssueReceiveComponent } from './operator/issue-receive/issue-receive.component';
import { BookInventoryComponent } from './operator/book-inventory/book-inventory.component';
import { SettingsComponent } from './operator/settings/settings.component';
import { BookExchangeComponent } from './operator/reports/book-exchange.component';
import { ReceiptPaymentReportComponent } from './operator/reports/receipt-payment-report.component';
import { ClosedMembersReportComponent } from './operator/reports/closed-members-report.component';
import { BookLocatorComponent } from './operator/book-locator/book-locator.component';
import { SearchByAuthorComponent } from './operator/search-by-author/search-by-author.component';
import { SearchByCategoryComponent } from './operator/search-by-category/search-by-category.component';
import { LabelConfigComponent } from './operator/label-config/label-config.component';
import { BookClaimsComponent } from './operator/book-claims/book-claims.component';
import { AddBookComponent } from './operator/add-book/add-book.component';
import { InterCenterTransferComponent } from './operator/inter-center-transfer/inter-center-transfer.component';
import { DailySummaryComponent } from './operator/daily-summary/daily-summary.component';
import { BookCatalogueComponent } from './operator/book-catalogue/book-catalogue.component';

const routes: Routes = [
  { path: 'dashboard', component: DashboardComponent, canDeactivate: [canDeactivateGuard] },
  { path: 'profile',   component: ProfileComponent },
  { path: 'books',      component: BookMasterComponent },
  { path: 'authors',    component: AuthorMasterComponent },
  { path: 'categories', component: CategoryMasterComponent },
  { path: 'languages',  component: LanguageMasterComponent },
  { path: 'members',    component: MemberMasterComponent },
  { path: 'add-member', component: MemberMasterComponent },
  { path: 'users',      component: UserMasterComponent },
  { path: 'routes',     component: RouteMasterComponent },
  { path: 'centers',         component: CenterMasterComponent },
  { path: 'closure-reasons', component: ClosureReasonMasterComponent },
  { path: 'barcode-labels',  component: BarcodeLabelsComponent },
  { path: 'issue-receive',   component: IssueReceiveComponent },
  { path: 'book-inventory',  component: BookInventoryComponent },
  { path: 'settings',              component: SettingsComponent },
  { path: 'reports/book-exchange',    component: BookExchangeComponent },
  { path: 'reports/transactions',     redirectTo: 'reports/book-exchange', pathMatch: 'full' }, // old path — keeps bookmarks working
  { path: 'reports/receipt-payment', component: ReceiptPaymentReportComponent },
  { path: 'reports/closed-members',  component: ClosedMembersReportComponent },
  { path: 'book-locator',          component: BookLocatorComponent },
  { path: 'search-by-author',   component: SearchByAuthorComponent },
  { path: 'search-by-category', component: SearchByCategoryComponent },
  { path: 'label-config',       component: LabelConfigComponent },
  { path: 'book-claims',        component: BookClaimsComponent },
  { path: 'add-book',           component: AddBookComponent },
  { path: 'inter-center-transfer', component: InterCenterTransferComponent },
  { path: 'daily-summary',    component: DailySummaryComponent },
  { path: 'book-catalogue',  component: BookCatalogueComponent },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
